import { functions } from './firebase';
import { statusCodes } from '../utilities/constants';

export const saveSubmission = async ({ user, storeGroups }) => {

  const storeGroup = storeGroups?.find(storeGroup =>
    storeGroup.ref.isEqual(user.submission?.storeGroupRef ? user.submission.storeGroupRef : null)
  );

  try {
    // console.log("save submission");
    // console.log(storeGroup ? storeGroup.id : undefined);
    const data = {
      id: user.id,
      submission: {
        approveIdentity: user.submission.approveIdentity,
        approvePersonalInfo: user.submission.approvePersonalInfo,
        approveSupportingDocuments: user.submission.approveSupportingDocuments,
        firstName: user.submission.firstName,
        lastName: user.submission.lastName,
        personalId: user.submission.personalId,
        memberCategory: user.submission.memberCategory,
        storeGroupId: storeGroup ? storeGroup.id : null,
        district: user.submission.district,
        statusCode: user.submission.statusCode,
        feedbackFromAdmin: user.submission.feedbackFromAdmin,
      },
      emailHtml: user.submission.emailHtml,
    };

    const response = await functions.httpsCallable('saveSubmission')(data);

    return { success: true, message: "Ansökan sparad." };
  } catch (error) {
    console.error("Could not save submission to database. ", error.message);
    if (error.code === 'invalid-argument') {
      alert(error.message);
    }
    return { success: false, message: "Kunde inte spara ansökan. " + error.message };
  }
};


